import React from 'react'

export function replaceHtmlEntityWithCharacter(value) {
  return extractTextValue(value, htmlEntityToCharacter)
}

export function replaceCharacterWithUnicodeCode(value) {
  return extractTextValue(value, characterToUnicodeCode)
}

export function extractTextValue(value, characterHelperCallback) {
  let textValue = value

  try {
    if (Array.isArray(value) === true) {
      for (let index = 0; index < value.length; index++) {
        const element = value[index]
        if (index === 0) {
          textValue = ''
        }

        if (characterHelperCallback) {
          textValue += characterHelperCallback(element)
        } else {
          textValue += element
        }
      }
    } else {
      if (characterHelperCallback) {
        textValue = characterHelperCallback(value)
      } else {
        textValue = value
      }
    }
  } catch (error) {
    console.log(error)
    textValue = value
  }

  return textValue
}

function htmlEntityToCharacter(text) {
  let safeTextValue = text

  if (safeTextValue) {
    safeTextValue = safeTextValue.replace('&micro;', 'µ')
    safeTextValue = safeTextValue.replace('&mu;', 'µ')
  }
  return safeTextValue
}

/// https://en.wikipedia.org/wiki/List_of_Unicode_characters
function characterToUnicodeCode(text) {
  let safeTextValue = text

  if (safeTextValue) {
    // Common
    safeTextValue = safeTextValue.replace('À', '\u00C0')
    safeTextValue = safeTextValue.replace('Á', '\u00C1')
    safeTextValue = safeTextValue.replace('Â', '\u00C2')
    safeTextValue = safeTextValue.replace('Ä', '\u00C4')
    safeTextValue = safeTextValue.replace('È', '\u00C8')
    safeTextValue = safeTextValue.replace('É', '\u00C9')
    safeTextValue = safeTextValue.replace('Ê', '\u00CA')
    safeTextValue = safeTextValue.replace('Ë', '\u00CB')
    safeTextValue = safeTextValue.replace('Í', '\u00CD')
    safeTextValue = safeTextValue.replace('Î', '\u00CE')
    safeTextValue = safeTextValue.replace('Ì', '\u00CC')
    safeTextValue = safeTextValue.replace('Ï', '\u00CF')
    safeTextValue = safeTextValue.replace('Ò', '\u00D2')
    safeTextValue = safeTextValue.replace('Ó', '\u00D3')
    safeTextValue = safeTextValue.replace('Ô', '\u00D4')
    safeTextValue = safeTextValue.replace('Ö', '\u00D6')
    safeTextValue = safeTextValue.replace('Ù', '\u00D9')
    safeTextValue = safeTextValue.replace('Ú', '\u00DA')
    safeTextValue = safeTextValue.replace('Û', '\u00DB')
    safeTextValue = safeTextValue.replace('Ü', '\u00DC')

    safeTextValue = safeTextValue.replace('á', '\u00E1')
    safeTextValue = safeTextValue.replace('â', '\u00E2')
    safeTextValue = safeTextValue.replace('à', '\u00E0')
    safeTextValue = safeTextValue.replace('ä', '\u00E4')

    safeTextValue = safeTextValue.replace('é', '\u00ED')
    safeTextValue = safeTextValue.replace('ê', '\u00EA')
    safeTextValue = safeTextValue.replace('è', '\u00E8')
    safeTextValue = safeTextValue.replace('ë', '\u00EB')

    safeTextValue = safeTextValue.replace('í', '\u00ED')
    safeTextValue = safeTextValue.replace('î', '\u00EE')
    safeTextValue = safeTextValue.replace('ì', '\u00EC')
    safeTextValue = safeTextValue.replace('ï', '\u00EF')

    safeTextValue = safeTextValue.replace('ó', '\u00F3')
    safeTextValue = safeTextValue.replace('ô', '\u00F4')
    safeTextValue = safeTextValue.replace('ò', '\u00F2')
    safeTextValue = safeTextValue.replace('ö', '\u00F6')

    safeTextValue = safeTextValue.replace('ú', '\u00FA')
    safeTextValue = safeTextValue.replace('û', '\u00FB')
    safeTextValue = safeTextValue.replace('ù', '\u00F9')
    safeTextValue = safeTextValue.replace('ü', '\u00FC')

    // German
    safeTextValue = safeTextValue.replace('ß', '\u00DF')

    // Spanish
    safeTextValue = safeTextValue.replace('Ñ', '\u00D1')
    safeTextValue = safeTextValue.replace('ñ', '\u00F1')

    // French
    safeTextValue = safeTextValue.replace('Ç', '\u00C7')
    safeTextValue = safeTextValue.replace('ç', '\u00E7')

    // Polish
    safeTextValue = safeTextValue.replace('Ć', '\u0106')
    safeTextValue = safeTextValue.replace('ć', '\u0107')
    safeTextValue = safeTextValue.replace('Ń', '\u0143')
    safeTextValue = safeTextValue.replace('ń', '\u0144')
    safeTextValue = safeTextValue.replace('Ś', '\u015A')
    safeTextValue = safeTextValue.replace('ś', '\u015B')
    safeTextValue = safeTextValue.replace('Ź', '\u0179')
    safeTextValue = safeTextValue.replace('ź', '\u017A')
    safeTextValue = safeTextValue.replace('Ż', '\u017B')
    safeTextValue = safeTextValue.replace('ż', '\u017C')
    safeTextValue = safeTextValue.replace('Ł', '\u0141')
    safeTextValue = safeTextValue.replace('ł', '\u0142')
    safeTextValue = safeTextValue.replace('Ą', '\u0104')
    safeTextValue = safeTextValue.replace('ą', '\u0105')
    safeTextValue = safeTextValue.replace('Ę', '\u0118')
    safeTextValue = safeTextValue.replace('ę', '\u0119')

    // Czech
    safeTextValue = safeTextValue.replace('Č', '\u010C;')
    safeTextValue = safeTextValue.replace('č', '\u010D')
    safeTextValue = safeTextValue.replace('Ď', '\u010E')
    safeTextValue = safeTextValue.replace('ď', '\u010F')
    safeTextValue = safeTextValue.replace('Ě', '\u011A')
    safeTextValue = safeTextValue.replace('ě', '\u011B')
    safeTextValue = safeTextValue.replace('Ň', '\u0147')
    safeTextValue = safeTextValue.replace('ň', '\u0148')
    safeTextValue = safeTextValue.replace('Ř', '\u0158')
    safeTextValue = safeTextValue.replace('ř', '\u0159')
    safeTextValue = safeTextValue.replace('Ŝ', '\u015C')
    safeTextValue = safeTextValue.replace('š', '\u015D')
    safeTextValue = safeTextValue.replace('Ť', '\u0164')
    safeTextValue = safeTextValue.replace('ť', '\u0165')
    safeTextValue = safeTextValue.replace('Ů', '\u016E')
    safeTextValue = safeTextValue.replace('ů', '\u016F')
    safeTextValue = safeTextValue.replace('Ý', '\u00DD')
    safeTextValue = safeTextValue.replace('ý', '\u00FD')
    safeTextValue = safeTextValue.replace('Ž', '\u017D')
    safeTextValue = safeTextValue.replace('ž', '\u017E')
  }

  return safeTextValue
}

function characterToHtmlEntity(text) {
  let safeTextValue = text

  // Common
  safeTextValue = safeTextValue.replace('Á', '&Aacute;')
  safeTextValue = safeTextValue.replace('á', '&aacute;')
  safeTextValue = safeTextValue.replace('Â', '&Acirc;')
  safeTextValue = safeTextValue.replace('â', '&acirc;')
  safeTextValue = safeTextValue.replace('À', '&Agrave;')
  safeTextValue = safeTextValue.replace('à', '&agrave;')
  safeTextValue = safeTextValue.replace('Ä', '&Auml;')
  safeTextValue = safeTextValue.replace('ä', '&auml;')

  safeTextValue = safeTextValue.replace('É', '&Eacute;')
  safeTextValue = safeTextValue.replace('é', '&eacute;')
  safeTextValue = safeTextValue.replace('Ê', '&Ecirc;')
  safeTextValue = safeTextValue.replace('ê', '&ecirc;')
  safeTextValue = safeTextValue.replace('È', '&Egrave;')
  safeTextValue = safeTextValue.replace('è', '&egrave;')
  safeTextValue = safeTextValue.replace('Ë', '&Euml;')
  safeTextValue = safeTextValue.replace('ë', '&euml;')

  safeTextValue = safeTextValue.replace('Í', '&Iacute;')
  safeTextValue = safeTextValue.replace('í', '&iacute;')
  safeTextValue = safeTextValue.replace('Î', '&Icirc;')
  safeTextValue = safeTextValue.replace('î', '&icirc;')
  safeTextValue = safeTextValue.replace('Ì', '&Igrave;')
  safeTextValue = safeTextValue.replace('ì', '&igrave;')
  safeTextValue = safeTextValue.replace('Ï', '&Iuml;')
  safeTextValue = safeTextValue.replace('ï', '&iuml;')

  safeTextValue = safeTextValue.replace('Ó', '&Oacute;')
  safeTextValue = safeTextValue.replace('ó', '&oacute;')
  safeTextValue = safeTextValue.replace('Ô', '&Ocirc;')
  safeTextValue = safeTextValue.replace('ô', '&ocirc;')
  safeTextValue = safeTextValue.replace('Ò', '&Ograve;')
  safeTextValue = safeTextValue.replace('ò', '&ograve;')
  safeTextValue = safeTextValue.replace('Ö', '&Ouml;')
  safeTextValue = safeTextValue.replace('ö', '&ouml;')

  safeTextValue = safeTextValue.replace('Ú', '&Uacute;')
  safeTextValue = safeTextValue.replace('ú', '&uacute;')
  safeTextValue = safeTextValue.replace('Û', '&Ucirc;')
  safeTextValue = safeTextValue.replace('û', '&ucirc;')
  safeTextValue = safeTextValue.replace('Ù', '&Ugrave;')
  safeTextValue = safeTextValue.replace('ù', '&ugrave;')
  safeTextValue = safeTextValue.replace('Ü', '&Uuml;')
  safeTextValue = safeTextValue.replace('ü', '&uuml;')

  // German
  safeTextValue = safeTextValue.replace('ß', '&szlig;')

  // Spanish
  safeTextValue = safeTextValue.replace('Ñ', '&Ntilde;')
  safeTextValue = safeTextValue.replace('ñ', '&ntilde;')

  // French
  safeTextValue = safeTextValue.replace('Ç', '&Ccedil;')
  safeTextValue = safeTextValue.replace('ç', '&ccedil;')

  // Polish
  safeTextValue = safeTextValue.replace('Ć', '&Cacute;')
  safeTextValue = safeTextValue.replace('ć', '&cacute;')
  safeTextValue = safeTextValue.replace('Ń', '&Nacute;')
  safeTextValue = safeTextValue.replace('ń', '&nacute;')
  safeTextValue = safeTextValue.replace('Ś', '&Sacute;')
  safeTextValue = safeTextValue.replace('ś', '&sacute;')
  safeTextValue = safeTextValue.replace('Ź', '&Zacute;')
  safeTextValue = safeTextValue.replace('ź', '&zacute;')
  safeTextValue = safeTextValue.replace('Ż', '&Zdot;')
  safeTextValue = safeTextValue.replace('ż', '&zdot;')
  safeTextValue = safeTextValue.replace('Ł', '&Lstrok;')
  safeTextValue = safeTextValue.replace('ł', '&lstrok;')
  safeTextValue = safeTextValue.replace('Ą', '&Aogon;')
  safeTextValue = safeTextValue.replace('ą', '&aogon;')
  safeTextValue = safeTextValue.replace('Ę', '&Eogon;')
  safeTextValue = safeTextValue.replace('ę', '&eogon;')

  // Czech
  safeTextValue = safeTextValue.replace('Č', '&Ccaron;')
  safeTextValue = safeTextValue.replace('č', '&ccaron;')
  safeTextValue = safeTextValue.replace('Ď', '&Dcaron;')
  safeTextValue = safeTextValue.replace('ď', '&dcaron;')
  safeTextValue = safeTextValue.replace('Ě', '&Ecaron;')
  safeTextValue = safeTextValue.replace('ě', '&ecaron;')
  safeTextValue = safeTextValue.replace('Ň', '&Ncaron;')
  safeTextValue = safeTextValue.replace('ň', '&ncaron;')
  safeTextValue = safeTextValue.replace('Ř', '&Rcaron;')
  safeTextValue = safeTextValue.replace('ř', '&rcaron;')
  safeTextValue = safeTextValue.replace('Ŝ', '&Scirc;')
  safeTextValue = safeTextValue.replace('š', '&scirc;')
  safeTextValue = safeTextValue.replace('Ť', '&Tcaron;')
  safeTextValue = safeTextValue.replace('ť', '&tcaron;')
  safeTextValue = safeTextValue.replace('Ů', '&Uring;')
  safeTextValue = safeTextValue.replace('ů', '&uring;')
  safeTextValue = safeTextValue.replace('Ý', '&Yacute;')
  safeTextValue = safeTextValue.replace('ý', '&yacute;')
  safeTextValue = safeTextValue.replace('Ž', '&Zcaron;')
  safeTextValue = safeTextValue.replace('ž', '&zcaron;')

  return safeTextValue
}
